import React from "react";
import { useLocation } from "react-router-dom";

import { Button, Header } from "../../../components";
import { useAppDispatch } from "../../../redux/store";
import { sendFrontendLog } from "../../../redux/frontendLog/asyncActions";

import styles from "./PaymentSuccess.module.scss";
import paymentErrorImg from "../../../assets/img/paymentErrorImg.svg";

export const PaymentError: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(sendFrontendLog({
      type: "Payment error page loaded",
      data: {
        component: "PaymentError",
        timestamp: new Date().toISOString(),
        url: window.location.pathname,
        userAgent: navigator.userAgent,
        errorMessage: location.state || 'Unknown error',
      },
    }));
  }, [location.state, dispatch]);

  return (
    <>
      <Header title={""} />
      <main>
        <section className="container">
          <p className={styles.subTitile}>Неудачная оплата</p>
          <p className={styles.subTitile}>{location.state ? location.state : null}</p>
          <div className={styles.image}>
            <img src={paymentErrorImg} alt="payment error" />
          </div>
          <div className={styles.linkButtons}>
            <Button newStyles={styles.button} to="/cart">
              Корзина
            </Button>
            <Button newStyles={styles.button} to="/subscriptions">
              Купить абонемент
            </Button>
            <Button newStyles={styles.button} to="/halls">
              Арендовать зал
            </Button>
          </div>
        </section>
      </main>
    </>
  );
};
